export default __webpack_public_path__ + "static/media/keyvisual-ingolstadt-eichstaett.3aa68093.jpg";